// src/components/shell/shortcuts.js
/**
 * The app's global keys, and the one rule that decides whether they apply.
 *
 * Kept apart from the components so the shortcut sheet lists exactly what the
 * handler implements — a printed list that drifts from the behaviour is worse
 * than no list.
 */

export const SHORTCUTS = [
    { keys: ['/'], label: 'Search files', scope: 'Anywhere' },
    { keys: ['Ctrl', 'K'], label: 'Open the command palette', scope: 'Anywhere' },
    { keys: ['?'], label: 'Show this list', scope: 'Anywhere' },
    { keys: ['Esc'], label: 'Close a dialog, or clear the selection', scope: 'Anywhere' },
    { keys: ['Ctrl', 'A'], label: 'Select every result', scope: 'Library' },
    { keys: ['←', '→'], label: 'Step to the previous / next file', scope: 'File details' },
];

/** True when the keystroke is going into a text field, where it belongs. */
export function isTypingTarget(target) {
    if (!target) return false;
    if (target.isContentEditable) return true;
    return ['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName);
}

/**
 * Which global shortcut, if any, an event means.
 *
 * `Ctrl/Cmd+K` works even while typing — that is the point of a palette you can
 * reach from a half-finished search box. The bare keys stand down whenever a
 * field has focus, and all of them stand down while a dialog owns the screen,
 * because a shortcut that fires behind a modal acts on something the user
 * cannot see.
 */
export function matchShortcut(e, { dialogOpen = false } = {}) {
    const typing = isTypingTarget(e.target);

    if ((e.ctrlKey || e.metaKey) && !e.altKey && e.key.toLowerCase() === 'k') {
        return dialogOpen ? null : 'palette';
    }
    if (e.ctrlKey || e.metaKey || e.altKey) return null;
    if (typing || dialogOpen) return null;

    if (e.key === '/') return 'search';
    if (e.key === '?') return 'shortcuts';
    return null;
}
